module.exports = "fragment Exception on HotlineScheduleExceptionType{__typename id startAt endAt message closed messageStartAt messageEndAt}"